// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridTransferirPassageiros_ButtonSection__MUfNa","StyledAsyncSelect":"gridTransferirPassageiros_StyledAsyncSelect__3bmPw"};